import { Properties } from "v2/infrastructure/common/types/FunctionPropertiesType";
import { Money } from "v2/domain/common/entities/Money";
import { BenefitTypeEnum } from "v2/domain/common/entities/BenefitType";
import Employee from "v2/domain/common/entities/Employee";

// eslint-disable-next-line
export enum RequestStates {
  PENDING = "pending",
  CANCELLED = "cancelled",
  APPROVED = "approved",
  DENIED = "denied",
}

// eslint-disable-next-line
export enum PaymentType {
  PUNCTUAL = "punctual-payment",
  RECURRENT = "recurrent-payment",
}

export default class Request {
  id: string;

  type: PaymentType;

  employee: Employee;

  category: BenefitTypeEnum;

  state: RequestStates;

  amount: Money;

  initialDate: Date;

  approvedDate?: Date | null;

  deniedDate?: Date | null;

  cancelledDate?: Date | null;

  details?: Record<string, any>;

  constructor({
    id = "",
    type = PaymentType.PUNCTUAL,
    employee = new Employee({
      id: "",
      name: "",
      surname: "",
      legalId: "",
      email: "",
    }),
    category = BenefitTypeEnum.RETIREMENT_INSURANCE_BENEFIT,
    state = RequestStates.PENDING,
    amount = Money.zero(),
    initialDate = new Date(),
    approvedDate,
    deniedDate,
    cancelledDate,
    details,
  }: Properties<Request>) {
    this.id = id;
    this.type = type;
    this.employee = employee;
    this.category = category;
    this.state = state;
    this.amount = amount;
    this.initialDate = initialDate;
    this.approvedDate = approvedDate;
    this.deniedDate = deniedDate;
    this.cancelledDate = cancelledDate;
    this.details = details;
  }
}
